import moment from "moment";
import { createDataPointProcessor } from "../utils/dataPointProcessor";
import { applyLineGraphState } from "../utils/lineGraphState";
import {
  initializeDictionaries,
  initializeEmotionDict,
  initializeActionDictionaries,
} from "../utils/dictionaries";
import { updateEmotions } from "./emotionHandler";
import {
  transform,
  transformActions,
  transformAllActions,
  transformFilteredData,
  transformStudentSupportData,
  computeParticipationPercentChange,
} from "../utils/transformers";
import {
  processAllDistricts,
  processAllSchoolsInDistrict,
  processSpecificSchool,
} from "../utils/processSchools";
import { timeHelper } from "../utils/timeHelper";
import {
  processSpecificClass,
  processSpecificStudent,
} from "../utils/processClasses";

export function handleTime(state, time, isCompare, syncCompareToCurrent = false) {
  const { currentDict, compareDict } = initializeDictionaries();
  const { currentActionDict, compareActionDict } =
    initializeActionDictionaries();
  const currentParticipants = new Set();
  const compareParticipants = new Set();
  const emotionDict = initializeEmotionDict();
  let impactfulActions = { action: {}, emotion: {} };
  let newState = {};
  let filterDataPoints = [];
  let studentEmotionData = {};
  let studentSupportData = {};
  const bigFiveFilteredData = [];
  const lineGraphSourceData = [];
  let tooltipCounts = initializeEmotionDict();

  const now = moment();
  const filtertime = timeHelper(time);
  const nextCompareDuration =
    !isCompare && syncCompareToCurrent ? filtertime : state.filterAmountCompare;
  let currentDate = moment().subtract(
    isCompare ? state.filterAmountCurrent : filtertime
  );
  let compareDate = moment().subtract(
    isCompare
      ? state.filterAmountCurrent + filtertime
      : filtertime + nextCompareDuration
  );

  let allEmotions = state.multiEmotion.emotions;

  const processDataPoint = createDataPointProcessor(
    currentDate,
    compareDate,
    now,
    state.chosenEmotion,
    currentDict,
    compareDict,
    currentActionDict,
    compareActionDict,
    impactfulActions,
    filterDataPoints,
    studentEmotionData,
    studentSupportData,
    bigFiveFilteredData,
    state.selectedTimes,
    state.selectedSubOptions,
    state.helpfulFilter,
    tooltipCounts,
    currentParticipants,
    compareParticipants,
    allEmotions,
    lineGraphSourceData
  );

  if (state.chosenDistrict === "All Districts") {
    processAllDistricts(state, processDataPoint);
  } else if (state.chosenSchool === "All Schools") {
    processAllSchoolsInDistrict(state, processDataPoint);
  } else if (state.chosenClass === "All Classes") {
    processSpecificSchool(state, state.chosenSchool, processDataPoint);
  } else if (state.chosenStudent === "All Students") {
    processSpecificClass(state, state.chosenClass, processDataPoint);
  } else {
    processSpecificStudent(state, state.chosenStudent, processDataPoint);
  }

  newState.filteredDataPoints = filterDataPoints;
  newState.bigFiveFilteredData = bigFiveFilteredData.sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );
  applyLineGraphState(
    newState,
    lineGraphSourceData,
    isCompare ? state.chosenTime : time,
    now
  );
  newState.tooltipCounts = tooltipCounts;

  updateTimeState(newState, time, filtertime, isCompare, syncCompareToCurrent);

  updateEmotions(
    state.feeling,
    state.filterAmountCurrent,
    state.district,
    state,
    emotionDict,
    newState
  );

  transform(currentDict, compareDict, newState);
  transformAllActions(currentActionDict, compareActionDict, newState);
  transformActions(impactfulActions, newState);
  transformFilteredData(studentEmotionData, state.chosenPercentage, newState);
  transformStudentSupportData(
    studentSupportData,
    state.chosenPercentage,
    newState
  );
  computeParticipationPercentChange(
    currentParticipants,
    compareParticipants,
    newState
  );

  return newState;
}

function updateTimeState(
  newState,
  time,
  filtertime,
  isCompare,
  syncCompareToCurrent = false
) {
  if (isCompare) {
    newState.filterAmountCompare = filtertime;
    newState.chosenTimeCompare = time;
  } else {
    newState.filterAmountCurrent = filtertime;
    newState.chosenTime = time;
    if (syncCompareToCurrent) {
      newState.filterAmountCompare = filtertime;
      newState.chosenTimeCompare = time;
    }
  }
}
